import "react";
import { styled as e } from "styled-components";
import { jsx as t } from "react/jsx-runtime";
import { logoLarge as n, logoSmall as r } from "@maat/assets";
//#region src/components/Logo/Logo.tsx
var i = {
	small: {
		width: "32px",
		height: "32px"
	},
	large: {
		width: "64px",
		height: "32px"
	}
}, a = e.img`
    display: block;
    width: ${({ $size: e }) => i[e].width};
    height: ${({ $size: e }) => i[e].height};
    object-fit: contain; /* preserves each SVG's aspect ratio within the box */
    flex-shrink: 0;
`, o = ({ size: e = "large", alt: i = "Maat", className: o }) => /* @__PURE__ */ t(a, {
	src: e === "small" ? r : n,
	$size: e,
	alt: i,
	className: o
});
//#endregion
export { o as Logo };
